import styled from "@emotion/styled"

export const LocaleGroupButton = styled.div`
  display: flex;
  padding: 4px;
  border-radius: 4px;
  background: ${(props) => props.selected ? props.theme.themeColorHighlight : "transparent"} ;
  color: ${(props) => props.selected ? "#ffffff" : props.theme.gray6} ;
`

export const Label = styled.div`
  padding: 4px;
`

export const AddQuestionButton = styled.div`
  border: 1px dashed ${(props) => props.theme.gray3};
  padding: 8px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  color: ${(props) => props.disabled ? props.theme.gray3 : props.theme.gray5};
  cursor: pointer;
  align-items: center;
  pointer-events: ${(props) => props.disabled ? "none" : "auto" };

  >.icon {
    padding-right: 8px;
  }
`

export const SettingsContainer = styled.div`
  height: calc(100% - 66px);
  overflow: ${(props) => props.multilingual ? "hidden" : "scroll"};
  display: flex;

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`

export const SettingsContent = styled.div`
  height: 100%;
  overflow-y: scroll;

  ::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
`